export function assertBrowser() {
  if (typeof window === 'undefined') {
    throw new Error('[MlSearchSession] mlSearchSession must only be used on the browser side');
  }
}
